import { render } from "./ApproveManyModal.vue?vue&type=template&id=2a5e5d16&scoped=true"
import script from "./ApproveManyModal.vue?vue&type=script&lang=js"
export * from "./ApproveManyModal.vue?vue&type=script&lang=js"

import "./ApproveManyModal.vue?vue&type=style&index=0&id=2a5e5d16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5e5d16"]])

export default __exports__